export default __webpack_public_path__ + "static/media/IC00049-support.31a6e38a.svg";